import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider } from "@/lib/auth";
import { ContentProvider } from "@/lib/ContentProvider";
import { LanguageProvider } from "@/lib/LanguageProvider";
import AmbientMusic from "@/components/AmbientMusic";
import Home from "@/pages/Home";
import Refuge from "@/pages/Refuge";
import Experiences from "@/pages/Experiences";
import Avis from "@/pages/Avis";
import Tarifs from "@/pages/Tarifs";
import BonCadeau from "@/pages/BonCadeau";
import GiftVoucher from "@/pages/GiftVoucher";
import GiftPrint from "@/pages/GiftPrint";
import Reserver from "@/pages/Reserver";
import Admin from "@/pages/Admin";
import Entry from "@/pages/Entry";
import ImmersiveExperience from "@/pages/ImmersiveExperience";
import MenuPetitDejeuner from "@/pages/MenuPetitDejeuner";
import Guide from "@/pages/Guide";
import GuideChapter from "@/pages/GuideChapter";
import GuideQR from "@/pages/GuideQR";
import CouchageFormulaire from "@/pages/CouchageSurvey";
import BreakfastSurvey from "@/pages/BreakfastSurvey";
import BainSurvey from "@/pages/BainSurvey";
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <LanguageProvider>
            <BrowserRouter>
              <ScrollToTop />
              <AmbientMusic />
              <Routes>
                <Route path="/admin/*" element={<Admin />} />
                <Route path="/" element={<Entry />} />
                {/* Version imprimable — sans layout ni nav */}
                <Route path="/bon-cadeau/:code/print" element={<GiftPrint />} />
                {/* Expérience digitale du bon cadeau — sans layout ni nav */}
                <Route path="/bon-cadeau/:code" element={<GiftVoucher />} />
                {/* Public : formulaire couchage 3e voyageur — URL statique unique */}
                <Route path="/formulaire-couchage" element={<CouchageFormulaire />} />
                {/* Legacy : anciens tokens envoyés avant simplification */}
                <Route path="/couchage/:token" element={<CouchageFormulaire />} />
                {/* Public : formulaire petit-déjeuner — lien individuel par réservation */}
                <Route path="/petit-dejeuner/:token" element={<BreakfastSurvey />} />
                {/* Public : précautions bain fleuri — lien individuel par réservation */}
                <Route path="/bain-fleuri/:token" element={<BainSurvey />} />
                <Route element={<Layout />}>
                  <Route path="/accueil" element={<Home />} />
                  <Route path="/refuge" element={<Refuge />} />
                  <Route path="/experiences" element={<Experiences />} />
                  <Route path="/experiences/petit-dejeuner/menu" element={<MenuPetitDejeuner />} />
                  <Route path="/experiences/:slug" element={<ImmersiveExperience />} />
                  <Route path="/avis" element={<Avis />} />
                  <Route path="/tarifs" element={<Tarifs />} />
                  <Route path="/bon-cadeau" element={<BonCadeau />} />
                  <Route path="/reserver" element={<Reserver />} />
                  <Route path="/guide" element={<Guide />} />
                  <Route path="/guide/qr" element={<GuideQR />} />
                  <Route path="/guide/:slug" element={<GuideChapter />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
          </LanguageProvider>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
